//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// event scheduler imports
import { IRendererProps } from "./EventScheduler.d";
import { EventScheduler } from "./EventScheduler";
import { eventSchedulerQuery } from "./EventScheduler.gql";
// util
import { handleReadyStateError } from "@util/relay.util";

//////////////////
// COMPONENT
//////////////////
export class EventSchedulerRenderer extends React.Component<IRendererProps> {
  public render() {
    const { environment } = this.props;

    return (
      <QueryRenderer
        environment={environment}
        query={eventSchedulerQuery}
        variables={{ calendarIds: [] }}
        cacheConfig={{ force: true }}
        render={(readyState: ReadyState) => {
          const viewer = readyState.props && readyState.props.viewer;

          // check for error or show a loader for first load
          if (readyState.error) {
            handleReadyStateError(readyState.error, "EventSchedulerRenderer");
            return;
          }

          if (!viewer) {
            return;
          }

          return <EventScheduler viewer={viewer} />;
        }}
      />
    );
  }
}
